import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProtectedProjectDetail from "./ProtectedProjectDetail";
import AccesoDenegado from "./pages/AccesoDenegado";
import UserMenu from "./components/UserMenu"; // ✅ menú de usuario

function ProjectApp({ user, onLogout }) {
  return (
    <div style={{ position: "relative" }}>
      {/* ✅ Menú del usuario */}
      <UserMenu user={user} onLogout={onLogout} />

      {/* Rutas del sitio */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/proyecto/:projectId" element={<ProtectedProjectDetail />} />
        <Route path="/acceso-denegado" element={<AccesoDenegado />} />
      </Routes>
    </div>
  );
}

export default ProjectApp;